<template>
	<div class="mainRight">
		<publicHotTag/>
		<!-- <publicClickRanking/> -->
	</div>
</template>

<script>
	import publicHotTag from '@/components/common/hotTag'
	import publicClickRanking from '@/components/common/clickRanking'
	
	export default{
		components:{
			publicHotTag,publicClickRanking
		}
	}
	
</script>

<style scoped>
	.mainRight{
		width: 330px;
		float: right;
	}
</style>
